import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Select,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { FaPlus, FaSearch } from "react-icons/fa";
import { componentState } from "../../../atoms/componentState";
import { BLUEMONEDDBUTTONS, GRAY_NEUTRAL, VARIANT, WHITE } from "../../../constants/colors";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import TableSuportSolicitation from "./components/tableSuportSolicitation";
import moment from "moment";
import { dateForAPI } from "../../../constants/dataFormat";
import ClientSelect from "../../../defaultComponents/ClientSelect";
import SystemApi from "../../../services/systemApi";
import { JWTToken } from "../listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import { goToAddSuport } from "../../../routes/coordinator";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";
export interface tipoServicoInterface {
  id: number;
  servico: string;
}
export interface servicoStatusInterface {
  id: number;
  situacao: string;
}

export default function Suport() {
  const setHeaderLocation = useSetRecoilState(componentState);
  useEffect(() => {
    setHeaderLocation("Solicitações de Suporte");
  }, []);
  const [search, setSearch] = useState("");
  const dataInicio = moment().startOf("day").format(dateForAPI);
  const dataFim = moment().endOf("day").format(dateForAPI);
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0];
  const cliente = user.idLoginTipo === 4 ? Number(jwtToken.idCliente) : Number(selectedId);
  // const cliente = Number(jwtToken.idCliente)

  const navigate = useNavigate();

  const initialValues = {
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
  };

  const [filtros, setFiltros] = useState(initialValues);
  const [listaTipoServico, setlistaTipoServico] = useState(
    Array<tipoServicoInterface>
  );
  const [listaServicoStatus, setlistaServicoStatus] = useState(
    Array<servicoStatusInterface>
  );

  async function getTipoServico() {
    try {
      const response = await SystemApi.getTipoServico();
      setlistaTipoServico(response);
    } catch (error) {
      console.log("error: ", error);
    }
  }
  async function getServicoStatus() {
    try {
      const response = await SystemApi.getServicoStatus();
      setlistaServicoStatus(response);
    } catch (error) {
      console.log("error: ", error);
    }
  }
  useEffect(() => {
    getTipoServico();
    getServicoStatus();
  }, [cliente]);

  const [statusId, setstatusId] = useState(0);
  const [tipoServicoId, setTipoServicoI] = useState(0);

  return (
    <Flex flexDir={"column"} height="100%" width="100%">
      <Box
        width={"100%"}
        bgColor={WHITE}
        height={"fit-content"}
        shadow={"md"}
        mt={"0.2%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
          {/* <Box w={"22%"}>
            <ClientSelect cliente={cliente} setCliente={setCliente} />
          </Box> */}
          <DateDropdown filtros={filtros} setFiltros={setFiltros} />
          <Select
            placeholder={"Tipos de serviço"}
            ml={4}
            w={"10vw"}
            value={tipoServicoId.toString()}
            onChange={(e: any) => {
              setTipoServicoI(Number(e.target.value));
            }}
          >
            {listaTipoServico &&
              listaTipoServico.map(
                (item: tipoServicoInterface, index: number) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.servico}
                    </option>
                  );
                }
              )}
          </Select>
          <Select
            placeholder={"Status de Serviço"}
            ml={4}
            value={statusId.toString()}
            w={"10vw"}
            onChange={(e: any) => {
              setstatusId(Number(e.target.value));
            }}
          >
            {listaServicoStatus &&
              listaServicoStatus.map(
                (item: servicoStatusInterface, index: number) => {
                  return (
                    <option key={index} value={item.id}>
                      {item.situacao}
                    </option>
                  );
                }
              )}
          </Select>
          <Button
            bgColor={GRAY_NEUTRAL}
            color={WHITE}
            onClick={() => {
              setFiltros(initialValues);
              setTipoServicoI(0);
              setstatusId(0);
            }}
          >
            Limpar Filtros
          </Button>
          <Button
            bgColor={BLUEMONEDDBUTTONS}
            color={WHITE}
            onClick={() => goToAddSuport(navigate)}
          >
            Nova Solicitação
          </Button>
          {/* <Button
            leftIcon={<FaPlus />}
            style={{ color: "white" }}
            // onClick={() => goToAddFornecedor(navigate)}
            _hover={{ bg: "#4B4B57" }}
            bgColor={VARIANT}
          >
            Nova Solicitação
          </Button> */}
        </Flex>
      </Box>
      <Box
        width={"100%"}
        bgColor={WHITE}
        height={"82vh"}
        shadow={"md"}
        overflowY={"scroll"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <TableSuportSolicitation
          search={search}
          dataInicio={filtros.initialDateFilter}
          dataFim={filtros.finalDateFilter}
          idCliente={cliente}
          status={statusId}
          tipoServico={tipoServicoId}
        />
      </Box>
    </Flex>
  );
}
